
import { z } from "zod";

export const RescheduleReasonValues = ["CREW_UNAVAILABLE", "DUE_TO_AHJ", "EARLIER_DATE_AVAILABLE", "MATERIALS_DELAY", "REQUESTED_BY_HOMEOWNER", "REQUESTED_BY_REMI", "STANDARD_SCHEDULING", "TASK_RESET_OR_DELETED", "WEATHER"] as const;
export const RescheduleReasonSchema = /* @__PURE__ */ z.enum(RescheduleReasonValues);
export const RescheduleReason: (typeof RescheduleReasonSchema)["enum"] = { "CREW_UNAVAILABLE": "CREW_UNAVAILABLE", "DUE_TO_AHJ": "DUE_TO_AHJ", "EARLIER_DATE_AVAILABLE": "EARLIER_DATE_AVAILABLE", "MATERIALS_DELAY": "MATERIALS_DELAY", "REQUESTED_BY_HOMEOWNER": "REQUESTED_BY_HOMEOWNER", "REQUESTED_BY_REMI": "REQUESTED_BY_REMI", "STANDARD_SCHEDULING": "STANDARD_SCHEDULING", "TASK_RESET_OR_DELETED": "TASK_RESET_OR_DELETED", "WEATHER": "WEATHER" };
export type RescheduleReason = (typeof RescheduleReasonValues)[number];
export const RescheduleReasonDisplayNames = { "CREW_UNAVAILABLE": "Crew unavailable",
"DUE_TO_AHJ": "Due to AHJ",
"EARLIER_DATE_AVAILABLE": "Earlier date available",
"MATERIALS_DELAY": "Materials delay",
"REQUESTED_BY_HOMEOWNER": "Requested by homeowner",
"REQUESTED_BY_REMI": "Requested by Remi",
"STANDARD_SCHEDULING": "Standard scheduling",
"TASK_RESET_OR_DELETED": "Task reset or deleted",
"WEATHER": "Weather", } satisfies Record<RescheduleReason, string>;
